import { FunctionComponent } from "react";
import { Marker as MarkerVis } from "@vis.gl/react-google-maps";

interface MarkerProps {
  position: { lat: number; lng: number };
  icon: string;
  name: string;
  height: number;
  width: number;
  anchorX: number;
  anchorY: number;
  isSelected: boolean;
  onClick: () => void;
}

const Marker: FunctionComponent<MarkerProps> = ({
  position,
  icon,
  name,
  height,
  width,
  anchorX,
  anchorY,
  isSelected,
  onClick,
}) => {
  return (
    <MarkerVis
      position={position}
      icon={{
        url: `data:image/svg+xml,${encodeURIComponent(icon)}`,
        anchor: new google.maps.Point(anchorX, anchorY),
        scaledSize: new google.maps.Size(width, height),
      }}
      zIndex={isSelected ? 1000 : 1}
      title={name}
      onClick={onClick}
    />
  );
};

Marker.displayName = "Marker";

export { Marker };
